import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const LifeInsuPaths: IPaths = {
  BimehNameh: {
    InformationAndPay: '/LifeInsu/InformationAndPay',
  },
};
